var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul-editor',{key:_vm.editorOptions.language,ref:"myMceEditor",attrs:{"height":_vm.height,"allowPaste":_vm.allowPaste,"toolbarOptions":_vm.toolbarOptions,"options":_vm.editorOptions,"uploaderConfig":{
    authorization: _vm.token,
    uptokenHost: _vm.COURSE_API_HOST,
    obsHost: _vm.RESOURCE_SERVER_HOST,
    config: {
      uphost: _vm.UPLOAD_SERVER_HOST,
      upprotocol: _vm.UPLOAD_SERVER_PROTOCOL,
    },
  }},on:{"change":_vm.onChange},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }